<template>
    <div class="container">
        <div class="row">dd
            <title-area class="p-0" title="Legjislacioni" />
            <div class="col-lg-8">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-6 ps-0">
                        <label>Kategoria33:</label>
                        <treeselect v-model="category" :multiple="true" :options="CategoryOptions"
                            placeholder="Zgjedh kategorinë..." />
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <label>Shfaq sipas intitucionit:</label>
                        <treeselect v-model="categoryValue2" :options="category_option2" :multiple="multipleSelect2"
                            placeholder="KPK,PSH,Të gjitha">
                            <template v-slot:value-label="{ node }">
                                {{ node.raw.customLabel }}
                            </template>
                        </treeselect>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                        <label>Filtro sipas datës:</label>
                        <VueDatePicker v-model="selectDate" range multi-calendars
                            placeholder="Data Fillimit - Mbarimit" />
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-lg-4 col-md-6 col-sm-6 ps-0">
                        <!-- <label>Kërko me fjalë kyqe:</label> -->
                        <input type="text" v-model="searchKeyword" placeholder="Kërko me fjalë kyqe..."
                            class="form-control" />
                    </div>
                    <EasyDataTable :headers="headers" :items="filteredItems" :rows-per-page="10" show-index filter-input
                        table-class="my-custom-table">
                        <template #header-action>
                            <div style="text-align: right; width: 100%">Veprime</div>
                        </template>
                        <template #item-action="{ item }">
                            <button @click="downloadFile(item)" class="downloadButton">
                                <font-awesome-icon icon="fa-solid fa-circle-down" />
                            </button>
                        </template>
                    </EasyDataTable>
                </div>
            </div>
            <div class="col-lg-4">
                LAJMET
            </div>
        </div>

    </div>
</template>

<script>
import titleArea from '../share/TitleArea.vue'
import Treeselect from 'vue3-treeselect'
import 'vue3-treeselect/dist/vue3-treeselect.css'
//Date Picker
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

//DataTable
import EasyDataTable from "vue3-easy-data-table"
import "vue3-easy-data-table/dist/style.css"
import axios from 'axios';


export default {


    data()
    {
        return {



            API_URL: "https://localhost:7131/api/v1/group-type/dashboard/seperate/",

            documentTypeUrl: "documettype",
            documentCategoryURL: 'documetCategory',
            documentSubCategoryURL: 'documetsubcategory',
            documentPostCatgoryUrl: 'documetpostcategory',
            documentStatusTypeUrl: 'documentStatus',
            prokuroriaURL: 'Prokurorit',
            publishedURL: 'POJO',


            selectDate: null,
            // Category1
            category: null,
            searchKeyword: "",

            CategoryOptions: [],



            // Category2
            multipleSelect2: true,
            categoryValue2: [],
            category_option2: ["KPK", "PSH", "Të gjitha"].map(i => ({
                id: i,
                label: `${i}`,
                customLabel: `${i}`,
            })),

            // Fill Table
            headers: [
                { text: "Titulli", value: "name", sortable: true, filterable: true },
                { text: "Data", value: "data", sortable: true, filterable: true },
                { text: "Veprime", value: "action", sortable: false }, // kolona e fundit për veprime
            ],

            items: [
                {
                    name: "Rregullore Nr.02.2025 për Plotesimin dhe Ndryshimin e Rregullores Nr.02.2023 për Veprimtarinë.Organizimin e Brendshëm dhe Sistematizimin e Administratës së KPK",
                    data: "01.05.2025",
                    category: "rregullore",
                    institution: "KPK"
                },
                {
                    name: "Rregullore Nr.01.2025 për Themelimin dhe Funksionimin e Ekipeve të  Përbashkëta të Hetimit",
                    data: "05.06.2024",
                    category: "rregullore",
                    institution: "PSH"
                },
                {
                    name: "Udhëzues për Panelin Vlerësues në zbatim të Rregullores 07 për Emërimin e KPSH-së dhe KP-ve, Nr.1831.2024",
                    data: "15.12.2020",
                    category: "Udhëzues",
                    institution: "KPK"
                },
                {
                    name: "LIGJI Nr. 06/L -025 PËR NDRYSHIMIN DHE PLOTËSIMIN E LIGJIT Nr. 03/L-225 PËR PROKURORIN E SHTETIT I NDRYSHUAR DHE PLOTËSUAR ME LIGJIN Nr. 05/L-034",
                    data: "17.02.2008",
                    category: "kushtetuta",
                    institution: "Të gjitha"
                },
                {
                    name: "LIGJI Nr. 06/L - 057 PËR PËRGJEGJËSINË DISIPLINORE TË GJYQTARËVE DHE PROKURORËVE",
                    data: "01.01.2021",
                    category: "ligjet",
                    institution: "PSH"
                },
                {
                    name: "Rregullore Nr. 09.2024 - për Themelimin e Marrëdhënies së Punës me Kontratë për Periudhë të Caktuar në Sistemin Prokurorial",
                    data: "01.01.2021",
                    category: "ligjet",
                    institution: "Të gjitha"
                },
                {
                    name: "LIGJI Nr. 06/L -025 PËR NDRYSHIMIN DHE PLOTËSIMIN E LIGJIT Nr. 03/L-225 PËR PROKURORIN E SHTETIT I NDRYSHUAR DHE PLOTËSUAR ME LIGJIN Nr. 05/L-034",
                    data: "17.02.2008",
                    category: "kushtetuta",
                    institution: "Të gjitha"
                },
                {
                    name: "LIGJI Nr. 06/L - 057 PËR PËRGJEGJËSINË DISIPLINORE TË GJYQTARËVE DHE PROKURORËVE",
                    data: "01.01.2021",
                    category: "ligjet",
                    institution: "PSH"
                },
                {
                    name: "Rregullore Nr. 09.2024 - për Themelimin e Marrëdhënies së Punës me Kontratë për Periudhë të Caktuar në Sistemin Prokurorial",
                    data: "01.01.2021",
                    category: "ligjet",
                    institution: "Të gjitha"
                },
                {
                    name: "Rregullore Nr. 03.2024 - për Procedurën e Rekrutimit, Pranimit, Emërimit dhe Punës Provuese për të Punësuarit në Administratën e Sistemit Prokurorial",
                    data: "01.01.2021",
                    category: "ligjet",
                    institution: "Të gjitha"
                },
                {
                    name: "Udhëzim Administrativ nr.03.2023 për Plotësimin dhe Ndryshimin e Udhëzimit Administrativ nr.01.2018 për Caktimin e Normës Orientuese për Prokurorët e Shtetit, nr.1179.2023",
                    data: "15.12.2020",
                    category: "Udhëzues",
                    institution: "KPK"
                },
                {
                    name: "Rregullore Nr.02.2025 për Plotesimin dhe Ndryshimin e Rregullores Nr.02.2023 për Veprimtarinë.Organizimin e Brendshëm dhe Sistematizimin e Administratës së KPK",
                    data: "01.05.2025",
                    category: "rregullore",
                    institution: "KPK"
                },
                {
                    name: "Rregullore Nr.01.2025 për Themelimin dhe Funksionimin e Ekipeve të  Përbashkëta të Hetimit",
                    data: "05.06.2024",
                    category: "rregullore",
                    institution: "PSH"
                },
                {
                    name: "Udhëzues për Panelin Vlerësues në zbatim të Rregullores 07 për Emërimin e KPSH-së dhe KP-ve, Nr.1831.2024",
                    data: "15.12.2020",
                    category: "Udhëzues",
                    institution: "KPK"
                },
                {
                    name: "LIGJI Nr. 06/L -025 PËR NDRYSHIMIN DHE PLOTËSIMIN E LIGJIT Nr. 03/L-225 PËR PROKURORIN E SHTETIT I NDRYSHUAR DHE PLOTËSUAR ME LIGJIN Nr. 05/L-034",
                    data: "17.02.2008",
                    category: "kushtetuta",
                    institution: "Të gjitha"
                },
                {
                    name: "LIGJI Nr. 06/L - 057 PËR PËRGJEGJËSINË DISIPLINORE TË GJYQTARËVE DHE PROKURORËVE",
                    data: "01.01.2021",
                    category: "ligjet",
                    institution: "PSH"
                },
                {
                    name: "Rregullore Nr. 09.2024 - për Themelimin e Marrëdhënies së Punës me Kontratë për Periudhë të Caktuar në Sistemin Prokurorial",
                    data: "01.01.2021",
                    category: "ligjet",
                    institution: "Të gjitha"
                },
                {
                    name: "LIGJI Nr. 06/L -025 PËR NDRYSHIMIN DHE PLOTËSIMIN E LIGJIT Nr. 03/L-225 PËR PROKURORIN E SHTETIT I NDRYSHUAR DHE PLOTËSUAR ME LIGJIN Nr. 05/L-034",
                    data: "17.02.2008",
                    category: "kushtetuta",
                    institution: "Të gjitha"
                },
                {
                    name: "LIGJI Nr. 06/L - 057 PËR PËRGJEGJËSINË DISIPLINORE TË GJYQTARËVE DHE PROKURORËVE",
                    data: "01.01.2021",
                    category: "ligjet",
                    institution: "PSH"
                },
                {
                    name: "Rregullore Nr. 09.2024 - për Themelimin e Marrëdhënies së Punës me Kontratë për Periudhë të Caktuar në Sistemin Prokurorial",
                    data: "01.01.2021",
                    category: "ligjet",
                    institution: "Të gjitha"
                },
                {
                    name: "Rregullore Nr. 03.2024 - për Procedurën e Rekrutimit, Pranimit, Emërimit dhe Punës Provuese për të Punësuarit në Administratën e Sistemit Prokurorial",
                    data: "01.01.2021",
                    category: "ligjet",
                    institution: "Të gjitha"
                },
                {
                    name: "Udhëzim Administrativ nr.03.2023 për Plotësimin dhe Ndryshimin e Udhëzimit Administrativ nr.01.2018 për Caktimin e Normës Orientuese për Prokurorët e Shtetit, nr.1179.2023",
                    data: "15.12.2020",
                    category: "Udhëzues",
                    institution: "KPK"
                }
            ],
        }
    },

    components: {
        Treeselect,
        titleArea,
        VueDatePicker,
        EasyDataTable
    },

    mounted()
    {

        this.fetchCategories();


    },

    computed: {

        // filteredCategoryOptions()
        // {
        //     const keyword = this.searchKeyword.trim().toLowerCase();
        //     if (!keyword) return this.category_option1;

        //     const filterRecursive = (items) =>
        //     {
        //         return items
        //             .map(item =>
        //             {
        //                 const match = item.label.toLowerCase().includes(keyword);
        //                 if (item.children)
        //                 {
        //                     const filteredChildren = filterRecursive(item.children);
        //                     if (filteredChildren.length || match)
        //                     {
        //                         return { ...item, children: filteredChildren };
        //                     }
        //                 } else if (match)
        //                 {
        //                     return item;
        //                 }
        //                 return null;
        //             })
        //             .filter(Boolean);
        //     };

        //     return filterRecursive(this.category_option1);
        // },

        filteredItems()
        {
            return this.items.filter(item =>
            {
                const keyword = this.searchKeyword.trim().toLowerCase();
                const matchKeyword = item.name.toLowerCase().includes(keyword);

                const matchCategory =
                    !this.category || this.category.length === 0 ||
                    this.category.includes(item.category);

                const matchInstitution =
                    !this.categoryValue2 || this.categoryValue2.length === 0 ||
                    this.categoryValue2.includes(item.institution);

                const matchDate =
                    !this.selectDate ||
                    (this.selectDate.length === 2 &&
                        this.isDateInRange(item.data, this.selectDate[0], this.selectDate[1]));

                return matchKeyword && matchCategory && matchInstitution && matchDate;
            });
        }
    },
    methods: {

        async fetchCategories()
        {

            try
            {
                const response = await axios.get(`${this.API_URL}${this.documentCategoryURL}`);

                this.CategoryOptions = response.data.map(item => ({
                    id: item.id,
                    label: item.title,

                }));

            }
            catch (error)
            {
                console.error("Error fetching categories:", error);

                // this.filteredCategoryOptions = [... ];

            }

        },
        downloadFile(item)
        {
            alert(item);
        },
        isDateInRange(itemDateStr, startDate, endDate)
        {
            const [day, month, year] = itemDateStr.split(".");
            const itemDate = new Date(`${year}-${month}-${day}`);
            return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
        },
    },


}
</script>

<style scoped>
input {
    padding-left: 5px;
    padding-right: 5px;
    display: table;
    table-layout: fixed;
    width: 100%;
    height: 36px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background: #fff;
}

.form-control:focus {
    border-color: #cfcfcf !important;
    box-shadow: none;
}

input::placeholder {
    color: #bdbdbd;
}

.downloadButton {
    border: none;
    background: none;
    float: right;
}
</style>